import { DateBox } from './DateBox';
import type { DateRangeBoxProps } from './types';

/** `DateBox` preset locked to `mode="range"` — a date range with no time. */
export function DateRangeBox(props: DateRangeBoxProps) {
  return <DateBox {...props} mode="range" />;
}
